// Vanilla CSS for the shared glass Card primitive. Prefix: gc-. Aggregated into
// libraryStyles (injected once in App.tsx). A 1:1 port of the design system's
// `Card` (pf-card): glass (frost + top sheen) / solid (white) / hero variants.
export const glassCardStyles = `
  .gc-card {
    position: relative;
    font-family: var(--font-sans);
    color: var(--text-secondary);
    border-radius: var(--rad-catchup-large);
    overflow: hidden;
  }
  .gc-card > * { position: relative; }
  /* frosted top-edge sheen (glass + hero only) */
  .gc-card::before {
    content: "";
    position: absolute;
    inset: 0 0 auto 0;
    height: 48%;
    background: var(--sheen-soft);
    pointer-events: none;
    z-index: 0;
  }
  .gc-card--glass {
    background: var(--glass-flat-bg);
    -webkit-backdrop-filter: var(--glass-flat-filter);
    backdrop-filter: var(--glass-flat-filter);
    border: 1px solid var(--glass-flat-border);
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  }
  /* solid white surface — dense tables / legibility */
  .gc-card--solid {
    background: var(--catchup-white);
    box-shadow: var(--shadow-card);
  }
  .gc-card--solid::before { display: none; }
  /* hero — larger radius + deeper float */
  .gc-card--hero {
    border-radius: var(--rad-catchup-xlarge);
    box-shadow: var(--glass-flat-edge), var(--glass-float);
  }
  .gc-card--pad { padding: var(--space-5); }
  .gc-card--interactive {
    cursor: pointer;
    transition: box-shadow var(--duration-base) var(--ease-glass),
      transform var(--duration-base) var(--ease-glass);
  }
  .gc-card--interactive:hover {
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-hover);
    transform: translateY(-2px);
  }
`;
